import { createApp } from '@wu/widget-core';
import { meta } from './meta';
import { Poll } from './poll';

export default createApp({ alias: meta.alias, name: meta.name }, Poll);
